import React, { Suspense, useMemo } from 'react'
import { useNavigate, useLocation, useParams, useRoutes } from 'react-router-dom'
import type { Location, NavigateFunction } from 'react-router-dom'
// import { useAnimatedRoutes as useRoutes } from '@/components/AnimatedRouter'
// import '@/components/AnimatedRouter/animate.scss'

// import LoadingPage from '@/components/LoadingTips'

import routes from './RouterConfig'

export * from './RouteAuth'
export * from './RouterBeforeEach'
export * from './WithRouter'

// 路由处理转化
const generateRouter = (routers: any) => {
    return routers.map((item: any) => {
        if (item.children) {
            item.children = generateRouter(item.children)
        }
        item.element = (
            <Suspense fallback={null}>
                <item.component />
            </Suspense>
        )
        return item
    })
}

const Router = () => useRoutes(generateRouter(routes))

interface IRouterHistory {
    push: (to: string, params?: any) => void
    replease: (to: string, params?: any) => void
    go: (delta: number) => void
    goBack: () => void
    goForward: () => void
}
export interface IWithRouterProps<P = any> {
    history: IRouterHistory
    route: Location & { params: P }
    router: {
        location: Location
        params: any
        navigate: NavigateFunction
    }
}
type ReactComponent = any
export function withRouter<P = any>(Component: ReactComponent) {
    function ComponentWithRouterProp(props: P) {
        const location = useLocation()
        const navigate = useNavigate()
        const params = useParams()
        const extra = location.state || {}

        const history = useMemo(() => {
            const history: IRouterHistory = {
                push: (to: string, params?: any) => {
                    navigate(to, { state: params })
                },
                replease: (to: string, params?: any) => {
                    navigate(to, { replace: true, state: params })
                },
                go: (delta: number) => {
                    navigate(delta)
                },
                goBack: () => {
                    navigate(-1)
                },
                goForward: () => {
                    navigate(1)
                }
            }

            return history
        }, [navigate])

        const route = useMemo(() => {
            return { ...location, params: { ...params, ...extra } }
        }, [location, params])

        const router = useMemo(() => {
            return { location, navigate, params }
        }, [location, navigate, params])

        return (
            // @ts-ignore
            <Component
                {...props}
                history={history}
                route={route}
                router={router}
            />
        )
    }
  
    return ComponentWithRouterProp;
}

export default Router
